// const API = process.env.NODE_ENV !== 'prod' ? 'https://local.asobol.pl' : 'https://api.zdrowiezaczynasiewglowie.com';
// const API = process.env.NODE_ENV !== 'prod' ? 'http://localhost:8000' : 'http://localhost:8000';
// const API = process.env.NODE_ENV !== 'prod' ? 'https://zdrowei-api.herokuapp.com' : 'https://zdrowei-api.herokuapp.com';
const API = process.env.NODE_ENV !== 'prod' ? 'https://api2.zdrowiezaczynasiewglowie.com' : 'https://api2.zdrowiezaczynasiewglowie.com';
// console.log(process.NODE_ENV);aa

const defaultHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
};

const defaultGetHeaders = {
  'Accept': 'application/json',
};

const defaultGetLdHeaders = {
  'Accept': 'application/ld+json',
};

const IRI = {
  me: 'panel/user/me/',
  user: '/panel/user/',
  company: '',
  course: '',
  tag: '',
  course2: '/panel/course/',
  code: '/panel/code/',
  codes: '/panel/codes/',
  storage: '',
  lecture: '',
  video: '',
  material: '/panel/material/',
  invitation: '/panel/invitation/',
  invitationCourse: '/panel/invitation-course/',
  exam: '/panel/exam/',
  question: '/panel/question/',
  answer: '/panel/answer/',
};

export default API;

export {
  defaultHeaders,
  defaultGetHeaders,
  defaultGetLdHeaders,
  IRI,
};
